<template>
  <div :style="{'width': imgWidth, 'top': top, 'left': left, 'right': right, 'bottom': bottom}"
       class="snowflake img-w" :class="`is-${color}`">
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M43.294 28.4257C34.7298 31.6683 30.5526 35.8454 27.3101 44.4096C27.0572 45.0991 26.5987 45.6942 25.9966 46.1147C25.3945 46.5352 24.6779 46.7606 23.9435 46.7606C23.2091 46.7606 22.4925 46.5352 21.8904 46.1147C21.2883 45.6942 20.8299 45.0991 20.577 44.4096C17.3344 35.8454 13.1572 31.6683 4.57391 28.4257C3.88447 28.1728 3.2893 27.7143 2.86885 27.1122C2.44839 26.5101 2.2229 25.7935 2.2229 25.0591C2.2229 24.3248 2.44839 23.6081 2.86885 23.006C3.2893 22.4039 3.88447 21.9455 4.57391 21.6926C13.1572 18.45 17.3344 14.2728 20.577 5.7086C20.8299 5.01916 21.2883 4.42398 21.8904 4.00352C22.4925 3.58307 23.2091 3.3576 23.9435 3.3576C24.6779 3.3576 25.3945 3.58307 25.9966 4.00352C26.5987 4.42398 27.0572 5.01916 27.3101 5.7086C30.5526 14.2728 34.7298 18.45 43.294 21.6926C43.9835 21.9455 44.5786 22.4039 44.9991 23.006C45.4195 23.6081 45.645 24.3248 45.645 25.0591C45.645 25.7935 45.4195 26.5101 44.9991 27.1122C44.5786 27.7143 43.9835 28.1728 43.294 28.4257Z" fill="url(#paint0_linear_2_455)"/>
      <path d="M46.1878 0.908573L36.6118 10.4846L37.9605 11.8333L47.5365 2.2573L46.1878 0.908573Z" fill="#393E46"/>
      <path d="M9.98543 37.0755L0.409424 46.6516L1.75816 48.0003L11.3342 38.4243L9.98543 37.0755Z" fill="#393E46"/>
      <path d="M38.0111 36.6607L36.6624 38.0095L46.2384 47.5855L47.5871 46.2367L38.0111 36.6607Z" fill="#393E46"/>
      <path d="M1.34873 0.000205955L0 1.34894L9.57599 10.9249L10.9247 9.5762L1.34873 0.000205955Z" fill="#393E46"/>
      <defs>
        <linearGradient id="paint0_linear_2_455" x1="44.7231" y1="4.28189" x2="3.16977" y2="45.859" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FFD939"/>
          <stop offset="0.06" stop-color="#FFD33B"/>
          <stop offset="0.38" stop-color="#FFB145"/>
          <stop offset="0.65" stop-color="#FF9C4B"/>
          <stop offset="0.83" stop-color="#FF954D"/>
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>

<script>
  export default {
    name: "Star2",
    props: {
      imgWidth: {
        default: '7rem'
      },
      top: {
        default: 'auto'
      },
      left: {
        default: 'auto'
      },
      right: {
        default: 'auto'
      },
      bottom: {
        default: 'auto'
      },
      color: {
        default: ''
      }
    },
  }
</script>

<style scoped lang="scss">
  .snowflake {
    position: absolute;
    z-index: 50;

    &.is-yellow {
      svg * {
        fill: $yellow;
      }
    }
    &.is-white {
      svg * {
        fill: white;
      }
    }
    &.is-orange {
      svg * {
        fill: #ffa848;
      }
    }
  }
</style>
